import React, { useState } from 'react';

import { useAuthContext } from '../../../Auth/AuthProvider';
import { Dropdown } from 'react-bootstrap';
import { GetStageSheet_getStageSheet_propDetails as ProppantDetails } from '../../../../types/schemaTypes';
import './StageSheet.scss';

interface WeightDetailsProps {
    stageSheetProppantId: number;
    totalWeight: number;
}

interface StageSheetDetailsProps {
    stageSheetBoxId: number;
    station: number;
    weightRemaining: number;
}

interface StageToEditProps {
    weightDetails: WeightDetailsProps[];
    stageSheetDetails: StageSheetDetailsProps[];
}

interface StageSheetWeightEditModeProps {
    proppantDetail: ProppantDetails;
    stagesToEdit: StageToEditProps;
    setStagesToEdit: React.Dispatch<React.SetStateAction<StageToEditProps>>;
}

const StageSheetWeightEditMode = ({
    proppantDetail,
    stagesToEdit,
    setStagesToEdit,
}: StageSheetWeightEditModeProps): React.ReactElement => {
    const [weight, setWeight] = useState(proppantDetail.totalWeightNeeded);

    const handleOnChangeInput = (value, proppantId) => {
        value = parseInt(value.toString().replace(/-+/, ''));
        value = parseInt(value.toString().replace(/e+/, ''));

        setWeight(value);

        const tempStagesToEdit = stagesToEdit;
        let exists = false;
        tempStagesToEdit.weightDetails.map(weightDetail => {
            if (weightDetail.stageSheetProppantId === proppantId) {
                exists = true;
                weightDetail.stageSheetProppantId = proppantId;
                weightDetail.totalWeight = value;
            }
        });

        if (!exists) {
            tempStagesToEdit.weightDetails.push({
                stageSheetProppantId: proppantId,
                totalWeight: value,
            });
        }
        setStagesToEdit(tempStagesToEdit);
    };

    return (
        <tr>
            <td>{proppantDetail.proppantName}</td>
            <td>
                <input
                    type="number"
                    className="StageSheet-Grid-Input"
                    value={weight ?? 0}
                    onChange={event =>
                        handleOnChangeInput(parseInt(event.target.value), proppantDetail.stageSheetProppantId)
                    }
                />
            </td>
            <td>{proppantDetail.sandPumped}</td>
            <td>{proppantDetail.totalBoxWeight}</td>
        </tr>
    );
};

export default StageSheetWeightEditMode;
